import type { TimelineToolbarItem } from '../types/timeline-toolbar-item.interface';
import { issueFiltersToolbarItem } from './o2d-issue-filters.toolbar-item';
import { resetToTodayToolbarItem } from './o2d-reset-to-today.toolbar-item';
import { compactViewToolbarItem, detailViewToolbarItem, standardViewToolbarItem } from './o2d-cell-width-view.toolbar-items';
import { addEntityMenuToolbarItem } from './o2d-add-entity-menu.toolbar-item';

/**
 * Default toolbar items for AbstractO2dTimelineView-based views.
 *
 * Returns 6 toolbar items:
 * - Issue Filters (position: 'start', order: -10)
 * - Reset to Today (position: 'start', order: 0)
 * - Compact / Standard / Detail View (position: 'start', order: 10 / 11 / 12; the active one
 *   carries the class `active`, see o2d-cell-width-view.toolbar-items.ts)
 * - Add Entity Menu (position: 'start', order: 20)
 *
 * The project board adds a seventh, its sort toggle, at order 15 (between detail view and
 * "add") — see `getToolbarItems()` in `views/boards/boards.view.ts`.
 *
 * The former 5th item, Burger Menu ("Einstellungen"), moved out of every
 * board's `.timeline-toolbar` into `ha-app`'s persistent sidebar (operator
 * request 2026-08-17) — see `getSubMenuItems` in `o2d-burger-menu.toolbar-item.ts`,
 * reused directly by `ha-app.component.ts`.
 *
 * @returns Array of default timeline toolbar items.
 */
export function defaultTimelineToolbarItems(): TimelineToolbarItem[] {
    return [
        issueFiltersToolbarItem,
        resetToTodayToolbarItem,
        compactViewToolbarItem,
        standardViewToolbarItem,
        detailViewToolbarItem,
        addEntityMenuToolbarItem,
    ];
}
